import { useState, useRef } from "react";
import { Form, useSubmit, useOutletContext } from "react-router-dom";
import Wrapper from "../../assets/wrappers/DashboardFormPage";
import {
  Loading,
  FormRow,
  FormRowSelect,
  FormRowSelectId,   // ← נוסיף כאן את FormRowSelectId
  NavLinkButton,
} from "../../components";
import {
  RSS_NEWS,
  WORK_ON_SATURDAY,
  MEMBER_TYPE,
  SORT_BY,
  BUILDING_TYPE,
} from "../../../../utils/constants.js";
import { useAllBuildingsContext } from "../../pages/AllBuildings.jsx";
import { useLocation } from "react-router-dom";

const BuildingSearchContainer = () => {
  const submit = useSubmit();
  const { user } = useOutletContext();
  const [isLoading, setIsLoading] = useState(false);
  const { maintenanceCompanies, cities } = useAllBuildingsContext();
  const qs = new URLSearchParams(useLocation().search);

  const formRef = useRef(null);

  const debounceTimeout = useRef(null);

  const handleSelectChange = (fieldName) => {
    return (e) => {
      let formElement;

      if (e && e.target) {
        formElement = e.currentTarget.form;
      } else {
        formElement = formRef.current;
      }

      // ננקה טיימאוט קודם אם קיים
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      const baseDelay = 100;
      debounceTimeout.current = setTimeout(async () => {
        setIsLoading(true);
        try {
          await submit(formElement);
        } catch (err) {
          // אפשר לטפל בשגיאה אם צריך
        } finally {
          setIsLoading(false);
        }
      }, baseDelay);
    };
  };

  const handleSearchChange = (e) => {
    const formElement = e.currentTarget.form;

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const totalDelay = 800 + 300; // 1100ms
    debounceTimeout.current = setTimeout(async () => {
      setIsLoading(true);
      try {
        await submit(formElement);
      } catch (err) {
        // טיפול בשגיאה אם צריך
      } finally {
        setIsLoading(false);
      }
    }, totalDelay);
  };

  return (
    <Wrapper>
      {/* 5. משייכים את ה־ref ל־Form */}
      <Form className="form" ref={formRef}>
        <h5 className="form-title">חיפוש בניין</h5>

        {isLoading && <Loading />}

        <div className="form-center">
          {/* 6. שדה החיפוש: משתמש ב־handleSearchChange */}
          <FormRow
            name="search"
            type="search"
            placeholder="חיפוש כינוי לבניין"
            labelText="חיפוש"
            defaultValue={qs.get("search") || ""}
            handleChange={handleSearchChange}
          />

          {/* 7. שדות SELECT בעלי ערכים פרימיטיביים */}
          <FormRowSelect
            labelText="תחומי החדשות שיופיעו בכתוביות"
            name="rssTitleNewsPath"
            defaultValue={qs.get("rssTitleNewsPath") || "הכל"}
            list={[...Object.values(RSS_NEWS), "הכל"]}
            handleChange={handleSelectChange("rssTitleNewsPath")}
          />

          <FormRowSelect
            labelText="פעילות בשבת"
            name="workOnSaturday"
            list={[...Object.values(WORK_ON_SATURDAY), "הכל"]}
            defaultValue={qs.get("workOnSaturday") || "הכל"}
            handleChange={handleSelectChange("workOnSaturday")}
          />

          <FormRowSelect
            labelText="סוג המסך"
            name="buildingType"
            list={[...Object.values(BUILDING_TYPE), "הכל"]}
            defaultValue={qs.get("buildingType") || "הכל"}
            handleChange={handleSelectChange("buildingType")}
          />

          <FormRowSelect
            labelText="עיר"
            name="city"
            list={["הכל", ...cities.map((c) => c.city)]}
            defaultValue={qs.get("city") || "הכל"}
            handleChange={handleSelectChange("city")}
          />

          {qs.get("city") !== "הכל" && (
            <FormRowSelect
              labelText="רחוב"
              name="street"
              list={[
                "הכל",
                ...(cities
                  .find((c) => c.city === qs.get("city"))
                  ?.streets.map((s) => s.street) || []),
              ]}
              defaultValue={qs.get("street") || "הכל"}
              handleChange={handleSelectChange("street")}
            />
          )}

          <FormRowSelect
            labelText="מיון עיר לפי"
            name="sort"
            list={Object.values(SORT_BY)}
            defaultValue={qs.get("sort") || "newest"}
            handleChange={handleSelectChange("sort")}
          />

          {/* 8. שדה של “חברת אחזקה” – משתמשים כעת ב־FormRowSelectId */}
          {user.role === "admin" && (
            <FormRowSelectId
              labelText="חברת אחזקה"
              name="maintenanceCompany"
              list={maintenanceCompanies}
              idField="_id"
              displayField="name"
              defaultValue={qs.get("maintenanceCompany") || "הכל"}
              handleChange={handleSelectChange("maintenanceCompany")}
            />
          )}

          <NavLinkButton
            text="ניקוי סינון"
            path="/dashboard/all-buildings"
            icon="clear"
            color="#758694"
          />
        </div>
      </Form>
    </Wrapper>
  );
};

export default BuildingSearchContainer;
